"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postDataDictionaryExportStart = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
const postDataDictionaryFieldsExportStart = (0, sonar_http_1.createPostEndpoint)((request) => `/api/v3/core/exports/fields/${request.sonarObjectId}/export/start`);
const postDataDictionaryTypesExportStart = (0, sonar_http_1.createPostEndpoint)((request) => `/api/v3/core/exports/sonar-object/types/${request.sonarObjectType}/export/start`);
const postDataDictionaryApplicationsExportStart = (0, sonar_http_1.createPostEndpoint)((request) => `/api/v3/core/exports/applications/${request.applicationId}/export/start`);
const postDataDictionaryTagsExportStart = (0, sonar_http_1.createPostEndpoint)((request) => `/api/v3/core/exports/datadictionary/tags/${request.tagId}/export/start`);
const postDataDictionaryComplianceCategoriesExportStart = (0, sonar_http_1.createPostEndpoint)((request) => `/api/v3/core/exports/datadictionary/compliance-categories/${request.complianceCategory}/export/start`);
const postDataDictionaryExportStart = (request) => {
    if (request.sonarObjectId) {
        return postDataDictionaryFieldsExportStart(request);
    }
    else if (request.sonarObjectType) {
        return postDataDictionaryTypesExportStart(request);
    }
    else if (request.applicationId) {
        return postDataDictionaryApplicationsExportStart(request);
    }
    else if (typeof request.complianceCategory === 'number') {
        return postDataDictionaryComplianceCategoriesExportStart(request);
    }
    return postDataDictionaryTagsExportStart(request);
};
exports.postDataDictionaryExportStart = postDataDictionaryExportStart;
//# sourceMappingURL=postDataDictionaryExportStart.js.map